import * as yup from 'yup'
import {
  DRAWER_ID_FOLDERS_CHANNELS_MEMBERS_EDIT,
  DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
} from 'ducks/drawers/ids'
import {
  DRAWER_TYPE_CHANNELS_AUTHENTICATE,
  DRAWER_TYPE_CHANNELS_MEMBERS_EDIT,
} from 'ducks/drawers/types'

export default {
  gmail: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    schema: yup.object().shape({
      id: yup.string().nullable(),
      name: yup.string().required('Mailbox name is required'),
      color: yup
        .string()
        .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
        .required('Mailbox color is required'),
    }),
    showEmail: false,
    drawerTitle: 'Add a mailbox',
    title: 'Give your mailbox a name',
    intro:
      'Give your mailbox a name and color which is shown will be shown in your email list.',
    formEmptyState: {
      id: null,
      name: '',
      color: '#59D015',
      channel_type: 'GOOGLE',
    },
  },
  messenger: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    schema: yup.object().shape({
      id: yup.string().nullable(),
      name: yup.string().required('Channel name is required'),
      color: yup
        .string()
        .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
        .required('Channel color is required'),
    }),
    showEmail: false,
    drawerTitle: 'Add a Messenger channel',
    title: 'Give your channel a name',
    intro:
      'Give your channel a name and color which is shown will be shown in your email list.',
    formEmptyState: {
      id: null,
      name: '',
      color: '#0e9cff',
    },
  },
  forwarding: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_MEMBERS_EDIT,
      type: DRAWER_TYPE_CHANNELS_MEMBERS_EDIT,
      closeIgnoresStack: true,
    },
    schema: yup.object().shape({
      id: yup.string().nullable(),
      email: yup
        .string()
        .email()
        .required('Mailbox email is required'),
      name: yup.string().required('Mailbox name is required'),
      color: yup
        .string()
        .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
        .required('Mailbox color is required'),
    }),
    showEmail: true,
    drawerTitle: 'Add a mailbox',
    title: 'Setup your mailbox details',
    intro: 'Fill in your email account information.',
    formEmptyState: {
      id: null,
      email: '',
      name: '',
      color: '#59D015',
      channel_type: 'FORWARDING',
    },
  },
}
